@if (!isAdminRoute()) {

  <app-header></app-header>

}

<router-outlet></router-outlet>


@if (!isAdminRoute()) {
  <app-footer></app-footer>
}
